var _linearGradient, _linearGradient2, _linearGradient3, _circle, _path, _path2, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChrome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-10 -10 276 276"
}, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  id: "chrome_a",
  x1: 145,
  x2: 34,
  y1: 253,
  y2: 61,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1e8e3e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#34a853"
}))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "chrome_b",
  x1: 111,
  x2: 222,
  y1: 254,
  y2: 62,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fcc934"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fbbc04"
}))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "chrome_c",
  x1: 17,
  x2: 239,
  y1: 80,
  y2: 80,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d93025"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ea4335"
}))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 128,
  r: 64,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#chrome_a)",
  d: "M96 183.4A63.7 63.7 0 0 1 72.6 160L17.2 64A128 128 0 0 0 128 256l55.4-96A64 64 0 0 1 96 183.4Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#chrome_b)",
  d: "M192 128a63.7 63.7 0 0 1-8.6 32L128 256A128 128 0 0 0 238.9 64h-111a64 64 0 0 1 64 64Z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 128,
  r: 52,
  fill: "#1a73e8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#chrome_c)",
  d: "M96 72.6a63.7 63.7 0 0 1 32-8.6h110.8a128 128 0 0 0-221.7 0l55.5 96A64 64 0 0 1 96 72.6Z"
})));
export default SvgChrome;